<template>
  <label class="flex items-center">
    <slot name="content" />
    <input
      class="free-checkbox__input sr-only"
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
    />
    <div class="free-checkbox"></div>
    <slot name="rightContent" />
  </label>
</template>

<script setup lang="ts">
  defineProps<{ checked: boolean; disabled?: boolean }>();
</script>

<style scoped>
  .free-checkbox {
    @apply relative shrink-0 rounded-md;
    width: var(--checkbox-width, 20px);
    height: var(--checkbox-height, 20px);
    border: 2px solid var(--color-checkbox-border, #d1d1d6);
    transition: background-color 0.2s;
  }

  .free-checkbox::after {
    @apply absolute inset-0 bottom-[3px] m-auto rotate-45 border-transparent;
    border-right-width: var(--checkmark-right-border, 2px);
    border-bottom-width: var(--checkmark-bottom-border, 2px);
    height: var(--checkmark-height, 9px);
    width: var(--checkmark-width, 6px);
    content: '';
  }

  .free-checkbox__input:checked + .free-checkbox::after {
    border-bottom-color: var(--color-checkbox-checked-border, #ffffff);
    border-right-color: var(--color-checkbox-checked-border, #ffffff);
  }

  .free-checkbox__input:checked + .free-checkbox {
    background-color: var(--color-checkbox-checked-border, #4ebc73);
    border-color: var(--color-checkbox-checked-border, #4ebc73);
  }

  .free-checkbox__input:disabled + .free-checkbox {
    @apply bg-situational-lightgrey border-situational-lightgrey;
  }
</style>
